var GradeLevelSpecifications = {
  "01_TEXT-SPE_read-the-book": {
    "default": ["2 specific details from the text, regardless of relevance to the question"]
  },
  "02_READ-COMP_fully-answered": {
    "default": ["Are all parts of the question answered?"]
  },
  "03_READ-COMP_answer-present": {
    "default": ["See Sample Answers"]
  },
  "04_MECH_capitalization": {
    "default": ["See Sample Answers"]
  },
  "05_MECH_grammar": {
    "default": ["See Sample Answers"]
  },
  "06_MECH_introduction": {
    "1": ["1. Not yet expected"],
    "2": ["1. Some context expected in the first sentence"],
    "3": ["1. Context expected in the first sentence"],
    "4": ["1. Somewhat-effectively introduce the topic or situation in the first sentence"],
    "5": ["1. Somewhat-effectively introduce the topic or situation in the first sentence"],
    "6": ["1. Somewhat-effectively introduce the topic or situation in the first sentence"],
    "7": ["1. Effectively introduces a topic or situation in the first sentence"],
    "8": ["1. Effectively introduces a topic or situation in the first sentence"],
    "9": ["1. Effectively introduces a topic or situation in the first sentence"]
  },
  "07_MECH_ling-accpt": {
    "default": ["1. Must use words with the intention of making meaning (not nonsense)"]
  },
  "08_MECH_punct": {
    "default": ["See Sample Answers"]
  },
  "09_MECH_repetitions": {
    "1": ["1. None: 2 repeates", "2. Some: 3 or fewer", "3. Many: more than 3"],
    "2": ["1. None: 1 repeate", "2. Some: 2 or 3 repeates", "3. Many: more than 3"],
    "3": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
    "4": ["1. None: none", "2. Some: 3 or fewer", "3. Many: more than 3"],
    "5": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
    "6": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
    "7": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
    "8": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
    "9": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"]
  },
  "10_READ-COMP_restating": {
    "1": ["1. not yet expected (but please click the correct evaluation anyway)"],
    "2": ["1. not yet expected (but please click the correct evaluation anyway)"],
    "3": ["1. restates at least one question asked"],
    "default": ["Restates all parts of the question/s?"]
  },
  "11_LEN_sent-count": {
    "1": ["1. One complete sentence"],
    "2": ["1. Two or more complete sentences"],
    "3": ["1. Two or more complete sentences"],
    "4": ["1. Two or more complete sentences"],
    "5": ["1. Two or more complete sentences"],
    "6": ["1. Three or more complete sentences"],
    "7": ["1. Four or more complete sentences"],
    "8": ["1. Four or more complete sentences"],
    "9": ["1. Four or more complete sentences"]
  },
  "12_MECH_sent-struct": {
    "1": ["Solid:", "1. Sentences have a subject & predicate (noun & verb)", "2. Not yet expected: Doesn't have run-on sentences"],
    "2": ["Solid:", "1. Sentences have a subject & predicate (noun & verb)", "2. If 3 or more sentences: Adjective or Adverb--1 used for every 3 sentences in answer", "3. If 3 or more sentences: Compound sentence with the conjunctions (and, but)--1 used for every 3 sentences in answer", "4. Doesn't have exclusively run-on sentences"],
    "3": ["Solid:", "1. sentences have a subject & predicate (noun & verb)", "2. If 3 or more sentences: Adjective or Adverb--1 used for every 3 sentences in answer", "3. If 3 or more sentences: Compound sentence with the conjunctions (and, but, for, neither/nor, or)--1 used for every 3 sentences in answer", "4. Doesn't have any run-on sentences"],
    "4": ["Solid:", "1. Complete sentences without fragments or run-ons", "2. Sentences are somewhat varied and complex"],
    "5": ["Solid:", "1. Complete sentences without fragments or run-ons", "2. Sentences are varied and complex", "3. Show understanding of usage of conjunctions", "4. Have accurate quotes from passages."],
    "6": ["Solid:", "1. Complete sentences without fragments or run-ons", "2. Sentences are appropriately varied, complex to enhance meaning."],
    "7": ["1. Solid: Effectively varies sentence patterns for meaning.", "2. Partial: Varies some sentence patterns for meaning.", "3. No structure: Has fragments, run-ons, and/or other sentence structure errors."],
    "8": ["1. Solid: Effectively varies sentence patterns for meaning.", "2. Partial: Varies some sentence patterns for meaning.", "3. No structure: Has fragments, run-ons, and/or other sentence structure errors."],
    "9": ["1. Solid: Effectively varies sentence patterns for meaning.", "2. Partial: Varies some sentence patterns for meaning.", "3. No structure: Has fragments, run-ons, and/or other sentence structure errors."]
  },
  "13_MECH_spelling": {
    "default": ["See Sample Answers"]
  },
  "14_TEXT-SPE_text-details-count": {
    "1": ["Two specific details"],
    "2": ["Two specific details"],
    "3": ["Two specific details"],
    "4": ["Two specific details"],
    "5": ["Three specific details"],
    "6": ["Three specific details"],
    "7": ["Four specific details"],
    "8": ["Five specific details"],
    "9": ["Six specific details"]
  },
  "15_MECH_transition": {
    "1": ["Not required", "1. But could be between ideas, sentences, or to show time (first, then, because, also)"],
    "2": ["Not required", "1. But could be between ideas, sentences or to show time (first, second, third, then, because, also; after, next, before, last)"],
    "3": ["Not required", "1. But could be between ideas, sentences, to show time, conclusion (first, second, third, then, because, also, after, next, before, last)", "2. Or to indicate more to come (besides, in addition)"],
    "4": ["Standard: At least 1 transition in answers of 3 or more sentences"],
    "5": ["Standard: At least 1 transition in answers of 3 or more sentences"],
    "6": ["Standard: At least 1 transition in answers of 3 or more sentences"],
    "7": ["Standard: Include a conclusion statement/s and use at least 1 transition per 3 sentences"],
    "8": ["Standard: Include a conclusion statement/s and use at least 1 transition per 3 sentences"],
    "9": ["Standard: Include a conclusion statement/s and use at least 1 transition per 3 sentences"]
  },
  "16_VOC_complex-vocab": {
    "1": ["One or more appropriate usages"],
    "2": ["One or more appropriate usages"],
    "3": ["One or more appropriate usages"],
    "4": ["Two or more appropriate usages"],
    "5": ["Two or more appropriate usages"],
    "6": ["Two or more appropriate usages"],
    "7": ["One or more appropriate usage"],
    "8": ["Two or more appropriate usages"],
    "9": ["Three or more appropriate usages"]
  },
  "17_TEXT-SPE_text-details-qual": {
    "default": ["Regardless of accuracy--do the details apply to the question asked?"]
  },
  "18_LEN_sent-count": {
    "1": ["Sentences have at least 2 words"],
    "2": ["Sentences have at least 4 words"],
    "3": ["Sentences have at least 5 words"],
    "4": ["Sentences have 5 or more words, or one sentence type"],
    "5": ["Sentences have 6 or more words, or one sentence type"],
    "6": ["Sentences have 7 or more words, or one sentence type"],
    "7": ["At least 2 types of sentences"],
    "8": ["At least 3 types of sentences"],
    "9": ["At least 4 types of sentences"]
  },
}


module.exports = GradeLevelSpecifications;


// WEBPACK FOOTER //
// ./modules/lib/academic/GradeLevelSpecifications.js